/*global VeloxWebView*/


/**
 * Extension to add volume compute popup
 */
var extension = {} ;
extension.name = "volume-field" ;

//must run after fields
extension.mustRunAfter = ["fields"] ;

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var volumeEls = Array.prototype.slice.apply(view.viewRootEl.querySelectorAll('[data-field-def="pool.p_volume"]'))
        .concat(Array.prototype.slice.apply(view.viewRootEl.querySelectorAll('[data-field-def="spa.s_volume"]'))) 
        .concat(Array.prototype.slice.apply(view.viewRootEl.querySelectorAll('[data-field-def="diag.p_volume"]'))) 
        .concat(Array.prototype.slice.apply(view.viewRootEl.querySelectorAll('[data-field-def="diag.s_volume"]'))) 
        ;
        
        volumeEls.forEach(function(volumeEl){
            if(volumeEl.isVolume){ return ;}
            
            volumeEl.isVolume = true;

            var isPool = volumeEl.getAttribute("data-field-def") === "pool.p_volume" ;
            volumeEl.className += " field-volume";
            //Append the comput button to the input of volume
            //(http://getbootstrap.com/docs/4.1/components/input-group/#button-addons)
            var inputEl = volumeEl.querySelector("input") ;
            var inputGroupEl = document.createElement("DIV") ;
            inputGroupEl.className = "input-group mb-3";
            inputEl.parentElement.insertBefore(inputGroupEl, inputEl) ;
            inputGroupEl.appendChild(inputEl) ;
            var divButtonEl = document.createElement("DIV") ;
            divButtonEl.className = "input-group-append" ;
            var buttonEl = document.createElement("BUTTON") ;
            buttonEl.type="button" ;
            buttonEl.setAttribute("tabindex", "-1") ;
            buttonEl.className = "btn btn-outline-primary" ;
            buttonEl.innerHTML = VeloxWebView.tr("form.compute") ;
            divButtonEl.appendChild(buttonEl);
            inputGroupEl.appendChild(divButtonEl) ;

            buttonEl.addEventListener("click", function(){
                var viewVolume = new VeloxWebView("views/fields", "volume") ;
                
                viewVolume.on("initDone", function(){
                    var data = {isPool: isPool} ;
                    if(isPool){
                        var pool = view.getBoundObject().pool ;
                        if(pool){
                            data.shape      = pool.p_shape;
                            data.width      = pool.p_width;
                            data.length     = pool.p_length;
                            data.depth      = pool.p_depth;
                            data.diameter   = pool.p_diameter;
                        }
                    }else{
                        var spa = view.getBoundObject().spa ;
                        if(spa){
                            data.shape      = spa.s_shape;
                            data.width      = spa.s_width;
                            data.length     = spa.s_length;
                            data.depth      = spa.s_depth;
                            data.diameter   = spa.s_diameter;
                        }
                    }
                    viewVolume.render(data) ;
                });
                viewVolume.openInPopup() ;
                viewVolume.on("computeDone", function(ev){
                    var data = ev.data ;
                    volumeEl.setValue(data.volume) ;
                    if(isPool){
                        var pool = view.getBoundObject().pool ;
                        if(!pool){ view.getBoundObject().pool = {}; pool = view.getBoundObject().pool ; }
                        pool.p_shape    = data.shape;
                        pool.p_width    = data.width;
                        pool.p_length   = data.length;
                        pool.p_depth    = data.depth;
                        pool.p_diameter = data.diameter;
                    }else{
                        var spa = view.getBoundObject().spa ;
                        if(!spa){ view.getBoundObject().spa = {}; spa = view.getBoundObject().spa ; }
                        spa.s_shape    = data.shape;
                        spa.s_width    = data.width;
                        spa.s_length   = data.length;
                        spa.s_depth    = data.depth;
                        spa.s_diameter = data.diameter;
                    }
                    viewVolume.closePopup() ;
                });
            }) ;
        });
    }) ;
} ;




module.exports = extension ;